import * as React from "react";

export class TemplateItem extends React.Component<TemplateItemProps, TemplateItemState> {
    static defaultProps: Partial<TemplateItemProps> = {};

    constructor(props: TemplateItemProps) {
        super(props);
        this.state = {

        };
    }

    public render() {
        return (
            <div className="sfTemplateItem" key={this.props.Id} onClick={x=>this.props.OnClick()} style={{position:'relative'}}>
                <div className="sfImage" style={{width:250}}>
                    <div style={{width:250,height:280}}>
                        <img style={{width:'100%',height:'100%'}}  src={'https://smartforms.rednao.com/wp-content/uploads/smart_forms_templates/template_'+this.props.Id+'/preview.png'}/>
                        {this.props.Requirements.length>0&&
                        <img style={{width:250,height:280,position:'absolute',top:0,left:0}}  src={smartFormsRootPath+'images/proonly.png'}/>
                        }
                    </div>

                </div>
                <div className={'templatePreview'} style={{position:'absolute',top:0,left:0,width:'100%',backgroundColor:'red',textAlign:'center',color:'white'}} onClick={e=>{
                    e.stopPropagation();
                    this.props.OnClickPreview();
                }}>
                    <span className={'fa fa-search'}/>
                    <span> </span>
                    Preview
                </div>
                <hr style={{margin:'1px 0 0 0'}}/>
                <div className="sfText"><h2 style={{fontSize:'17px !important',textAlign:'center'}}>{this.props.Name}</h2></div>
            </div>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateItemProps {
    Id:string;
    Name:string;
    Requirements:string[];
    OnClick:any;
    OnClickPreview:any;
}

interface TemplateItemState {

}

//#endregion "My Region"